import { render } from "./v-parent-details.vue?vue&type=template&id=b23f3e42"
import script from "./v-parent-details.vue?vue&type=script&lang=js"
export * from "./v-parent-details.vue?vue&type=script&lang=js"

import "./v-parent-details.vue?vue&type=style&index=0&id=b23f3e42&lang=css"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__